var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9999 92.0452C71.8757 92.0452 92.0416 71.8794 92.0416 47.0036C92.0416 22.1278 71.8757 1.96191 46.9999 1.96191C22.1241 1.96191 1.95825 22.1278 1.95825 47.0036C1.95825 71.8794 22.1241 92.0452 46.9999 92.0452Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9067 21.1738L68.2087 36.8718",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1323 25.7909L72.8773 10.0459",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1697 83.9109L36.8677 68.2129",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7913 57.1367L10.0933 72.8347",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8579 83.8913L57.1638 68.1973",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2244 57.1055L83.9263 72.8074",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1128 21.1465L25.803 36.8406",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8989 25.7752L21.197 10.0732",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47 70.5039C59.9787 70.5039 70.5 59.9826 70.5 47.0039C70.5 34.0252 59.9787 23.5039 47 23.5039C34.0213 23.5039 23.5 34.0252 23.5 47.0039C23.5 59.9826 34.0213 70.5039 47 70.5039Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/help-support.5fccb5bbffe84cca3cc1fc26f4f09140.svg";
export { ForwardRef as ReactComponent };